import { render, staticRenderFns } from "./BrandsHeader.vue?vue&type=template&id=540825de&"
import script from "./BrandsHeader.vue?vue&type=script&lang=ts&"
export * from "./BrandsHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BrandsHeader.vue?vue&type=style&index=0&id=540825de&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports